export const getFormattedNumber = (value: number | undefined) => {
    value = value ? value : 0;
    const temp = (Math.round(value / 10) / 100).toFixed(2);
    return temp
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
};

export const getFormattedPercentage = (value: number) => {
    value = value ? value : 0;
    const temp = (Math.round(Math.abs(value) * 10000) / 100).toFixed(2);
    return temp
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
};

export const getMonth = (value: number | undefined) => {
    switch (value) {
        case 1:
            return 'Leden';
        case 2:
            return 'Únor';
        case 3:
            return 'Březen';
        case 4:
            return 'Duben';
        case 5:
            return 'Květen';
        case 6:
            return 'Červen';
        case 7:
            return 'Červenec';
        case 8:
            return 'Srpen';
        case 9:
            return 'Září';
        case 10:
            return 'Říjen';
        case 11:
            return 'Listopad';
        case 12:
            return 'Prosinec';
    }
};

export const getMonthNumber = (value: string | undefined) => {
    switch (value) {
        case 'Leden':
            return 1;
        case 'Únor':
            return 2;
        case 'Březen':
            return 3;
        case 'Duben':
            return 4;
        case 'Květen':
            return 5;
        case 'Červen':
            return 6;
        case 'Červenec':
            return 7;
        case 'Srpen':
            return 8;
        case 'Září':
            return 9;
        case 'Říjen':
            return 10;
        case 'Listopad':
            return 11;
        case 'Prosinec':
            return 12;
    }
};
